import './styles/main.scss'
import './styles/pages/_case-studies.scss'
import './scripts/common'
import './scripts/nav'
import './scripts/footer'
import Slideshow from './models/Slideshow'

new Slideshow('#slideshow')
